(() => {
  const init = (scope = document) => {
    const header = scope.querySelector?.('[data-kt15-header]') || document.querySelector('[data-kt15-header]');
    if (!header || header.dataset.kt28MobileReady === 'true') return;
    header.dataset.kt28MobileReady = 'true';

    const button = header.querySelector('[data-kt6-menu-toggle]');
    const nav = header.querySelector('[data-kt6-mobile-nav]');
    if (!button || !nav) return;

    const sync = () => {
      const open = button.getAttribute('aria-expanded') === 'true' && !nav.hidden;
      document.body.classList.toggle('kt28-mobile-menu-open', open && window.innerWidth <= 1050);
    };

    button.addEventListener('click', () => requestAnimationFrame(sync));

    nav.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      button.setAttribute('aria-expanded', 'false');
      nav.hidden = true;
      header.classList.remove('is-mobile-open');
      document.body.classList.remove('kt28-mobile-menu-open');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || nav.hidden) return;
      button.setAttribute('aria-expanded', 'false');
      nav.hidden = true;
      header.classList.remove('is-mobile-open');
      document.body.classList.remove('kt28-mobile-menu-open');
      button.focus();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1050) document.body.classList.remove('kt28-mobile-menu-open');
      else sync();
    }, { passive: true });
  };

  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
